import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { locationCategories, locationTypes } from "../../Components/common/Constants";
import { Button, Row, Col, Select, message, Table, Modal, Divider, Flex, Descriptions, Tag, Tooltip, Checkbox, Space } from "antd";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, CloseOutlined, DeleteFilled, DownloadOutlined, FileOutlined, InboxOutlined, PictureOutlined, PlusOutlined } from "@ant-design/icons";
import DeleteIcon from "@mui/icons-material/Delete";
import qs from "query-string";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import { domain, env, wms_uploads_bucket, wms_uploads_cdn } from "../../Components/config";
import { decodeId, extractOriginalFileName, getNewFileName, handleSubmitImage, handleSubmitSingleImage } from "../../Components/common/CommonFun";

import { Image, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import InfoCards from "../../Components/InfoCards";
import DetailsGrid from "../../Components/common/DetailsGrid";
import { FileImageSection } from "../../Components/common/FileImageSection";

const Auth = new AuthService();

export default function Product(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const listState = location?.state || null;
  const decodedID = decodeId(params?.id)
  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const { locations, products, aisles, roles, type: roleType } = useSelector((state) => state?.AppState?.userCreds);
  const canAccess =
    roleType === 0 ||
    roleType === 1 ||
    (roleType === 2 && roles?.some((role) => role.role_id === 4));
  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [productLocations, setProductLocations] = React.useState([]);
  const [allProductLocations, setAllProductLocations] = React.useState([]);
  const [addLocationModalOpen, setAddLocationModalOpen] = React.useState(false);
  const [newLocationDetail, setNewLocationDetail] = React.useState({
    location_id: null,
    product_id: id,
    location_type: null,
    aisle: null,
    is_picking: false,
    is_binning: false,
  });

  const [productDetail, setProductDetail] = React.useState({
    code: '',
    title: ''
  });

  const [files, setFiles] = React.useState([]);
  const [currentItemFiles, setCurrentItemFiles] = React.useState([]);
  const [profileFiles, setProfileFiles] = React.useState();
  const [currentItemFilesProfile, setCurrentItemFilesProfile] = React.useState();
  const [galleryFiles, setGalleryFiles] = React.useState([]);
  const [currentItemFilesGallery, setCurrentItemFilesGallery] = React.useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);

  const submitImage = (e) => {
    e.persist?.();
    handleSubmitImage(e, setFiles, setCurrentItemFiles)
  }

  const submitProfileImage = (e) => {
    e.persist?.();
    handleSubmitSingleImage(e, setProfileFiles, setCurrentItemFilesProfile, true)
  }

  const submitGalleryImage = (e) => {
    e.persist?.();
    handleSubmitImage(e, setGalleryFiles, setCurrentItemFilesGallery)
  }

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteFileProfile = () => {
    setProfileFiles('');
    setCurrentItemFilesProfile('');
  };

  const handleDeleteFileGallery = (fileName) => {
    const updatedFiles = galleryFiles?.filter((file) => file.name !== fileName);
    setGalleryFiles(updatedFiles);
    setCurrentItemFilesGallery(currentItemFilesGallery?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const handleDeleteCurrentFileProfile = () => {
    setCurrentItemFilesProfile('');
    setProfileFiles('');
  };

  const handleDeleteCurrentFileGallery = (itemToDelete) => {
    setCurrentItemFilesGallery(
      currentItemFilesGallery.filter((item) => item !== itemToDelete)
    );

  };

  const getUploadUrl = async (file) => {
    const params = {
      bucket: wms_uploads_bucket,
      ContentType: file.file.type,
      Key: env + "/warehouse-products/" + id + "/" + file.name,
    };
    const response = await fetch(
      `${domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };


  const getProductLocations = async () => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/product-location/location-stock-by-product?id=${id}`)
      if (res?.ack) {
        console.log(res);
        setProductLocations(res?.product_location)
      } else {
        showMessage('error', res?.message)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getAllProductLocations = async () => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/product/product-picking-locations?id=${id}`)
      if (res?.ack) {
        console.log(res);
        setAllProductLocations(res?.product_picking_locations)
      } else {
        showMessage('error', res?.message)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  React.useEffect(() => {
    if (id > 0) {
      getProductFiles()
      getProductLocations()
      getAllProductLocations()
      const product = products?.find((item) => item?.netsuite_id == id)
      setProductDetail({ ...productDetail, code: product?.code, title: product.name })
    }
  }, [id])


  const onClickCancel = () => {
    // If we have saved list state, return with it; otherwise go back
    if (listState) {
      navigate('/products', { state: listState });
    } else {
      navigate('/products');
    }
  };

  const productLocationsCol = [

    {
      title: 'Location',
      render: (record) => {
        const selected = locations?.find((item) => item.id == record?.location_id)
        return (
          <>
            <Flex gap={4}>
              {selected?.is_picking > 0 ? (
                <Tag color="green" >Picking</Tag>
              ) : null}
              {selected?.is_binning > 0 ? (
                <Tag color="warning" >Binning</Tag>
              ) : null}
              {selected?.is_transit > 0 ? (
                <Tag color="red" >Transit</Tag>
              ) : null}
              {selected?.code}
            </Flex>


          </>
        );
      }
    },
    // {
    //   title: 'Product',
    //   render: (record) => {
    //     const selected = products?.find((item) => item.netsuite_id == record?.product_netsuite_id)
    //     return (
    //       <>
    //         {`${selected?.code} - ${selected?.name}`}
    //       </>
    //     );
    //   }
    // },
    {
      title: 'Aisle',
      render: (record) => {
        const selectedLocation = locations?.find((item) => item.id == record?.location_id)
        const selected = aisles?.find((item) => item.id == selectedLocation?.aisle_id)
        return (
          <>
            {`${selected?.title} `}
          </>
        );
      }
    },
    // {
    //   title: 'Location Type',
    //   render: (record) => {
    //     const selected = locationCategories?.find((item) => item.id == record?.type)
    //     return (
    //       <>
    //         {`${selected?.title} `}
    //       </>
    //     );
    //   }
    // },
    {
      title: 'Stock',
      // dataIndex: 'stock_level',
      // key: 'stock_level',
      align: 'center',
      render: (text, record) => {
        const formattedStock = Number(record?.stock_level).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return (
          <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{formattedStock} </Tag>
          // <span >
          //   {formattedStock}
          // </span>
        );
      }
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   align: "right",
    //   dataIndex: '',
    //   render(record) {
    //     return (
    //       <div >

    //         <DeleteFilled style={
    //           {
    //             fontSize: "25px",
    //             cursor: "pointer",
    //             color: "#cd1437",
    //           }} onClick={() => {
    //             Modal.confirm({
    //               title: 'Delete Location',
    //               centered: true,
    //               content: `Are you sure you want to delete this location?`,
    //               onOk: () => deleteLocation(record.id),
    //               okText: 'Delete',
    //               cancelText: 'Cancel',
    //               width: 600,
    //               okButtonProps: { size: "large" },
    //               cancelButtonProps: { size: "large" },
    //             });
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },

  ];

  const allProductLocationsCol = [

    {
      title: 'Location',
      render: (record) => {
        console.log('Selected', record, locations);
        const selected = locations?.find((item) => item.id == record?.location_id)
        console.log('Selected', selected);

        return (
          <>
            <Flex gap={4}>
              {selected?.is_picking > 0 ? (
                <Tag color="green" >Picking</Tag>
              ) : null}
              {selected?.is_binning > 0 ? (
                <Tag color="warning" >Binning</Tag>
              ) : null}
              {selected?.is_transit > 0 ? (
                <Tag color="red" >Transit</Tag>
              ) : null}
              {selected?.code}
            </Flex>


          </>
        );
      }
    },
    {
      title: 'Aisle',
      render: (record) => {
        const selectedLocation = locations?.find((item) => item.id == record?.location_id)
        const selected = aisles?.find((item) => item.id == selectedLocation?.aisle_id)
        return (
          <>
            {`${selected?.title} `}
          </>
        );
      }
    },

  ];

  const deleteLocation = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product-location/product-location`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getProductLocations();
        showMessage('success', res?.message);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleModalCancel = () => {
    setAddLocationModalOpen(false);
    setNewLocationDetail({
      location_id: null,
      product_id: null,
      location_type: null,
      aisle: null,
      is_picking: false,
      is_binning: false,
    });
  };

  const getAllPro = async () => {
    showLoading(layoutDispatch)
    try {
      const currentTime = new Date().getTime();

      const res = await Auth.fetch(`/product/products`);
      if (res.ack) {
        if (res?.products.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_PRODUCTS',
            payload: { products: res?.products, timestamp: newTimestamp },
          });
        }

        // setProducts(res?.products)
      } else {
        showMessage('error', res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage('error', "Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };


  const handleOk = async () => {

    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    const validations = [
      { key: 'location_id', message: 'Please add location' },
      // { key: 'location_type', message: 'Please add location type' },
      // { key: 'aisle', message: 'Please add aisle' },

    ];

    for (const { key, message: errorMessage } of validations) {
      if (isEmptyOrUndefined(newLocationDetail?.[key])) {
        showMessage('error', errorMessage);
        return;
      }
    };

    showLoading(layoutDispatch);
    const dataToSend = {
      // type: newLocationDetail.location_type,
      location_id: newLocationDetail?.location_id,
      product_netsuite_id: id,
      aisle_id: newLocationDetail.aisle,
      is_picking: 1,
      is_binning: 0,

    }
    try {
      const res = await Auth.fetch("/product-location/product-location", {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      })
      if (res?.ack) {
        showMessage('success', res?.message);
        getAllPro();
        setAddLocationModalOpen(false)
        getProductLocations()
        getAllProductLocations();
        setNewLocationDetail({
          location_id: null,
          product_id: null,
          location_type: null,
          aisle: null,
          is_picking: false,
          is_binning: false,
        });

      } else {
        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const totalStock = productLocations?.reduce((acc, item) => {
    return acc + Number(item.stock_level)
  }, 0);

  // const saveProductFiles = async () => {
  //   showLoading(layoutDispatch);
  //   try {
  //     const res = await Auth.fetch(`/product/product-files`, {
  //       method: "POST",
  //       body: JSON.stringify({
  //         product_netsuite_id: id,
  //         files: currentItemFiles,
  //         profile_image: currentItemFilesProfile,
  //       })
  //     });
  //     if (res?.ack) {
  //       const uploadPromises = [];
  //       const uploadPromisesProfile = [];
  //       if (files.length > 0) {
  //         files.forEach((f) => {
  //           uploadPromises.push(
  //             getUploadUrl(f)
  //               .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
  //               .catch(error => console.error("Error uploading file:", error))
  //           );
  //         });
  //       }
  //       if (profileFiles.length > 0) {
  //         profileFiles.forEach((f) => {
  //           uploadPromises.push(
  //             getUploadUrl(f)
  //               .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
  //               .catch(error => console.error("Error uploading file:", error))
  //           );
  //         });
  //       }
  //       await Promise.all(uploadPromises);
  //       await Promise.all(uploadPromisesProfile);
  //       showMessage('success',res?.message);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     showMessage('error','Something went wrong')
  //   }
  //   finally {
  //     hideLoading(layoutDispatch);
  //   }
  // };


  const saveProductFiles = async () => {

    showLoading(layoutDispatch);
    const productDetails = products?.find((item) => item.netsuite_id == id);
    try {
      // Step 1: Save product file metadata first
      const res = await Auth.fetch(`/product/product-files`, {
        method: "POST",
        body: JSON.stringify({
          product_netsuite_id: id,
          files: currentItemFiles,
          profile_image: currentItemFilesProfile || '',
          gallery_images: currentItemFilesGallery,
          product_name: productDetails?.name || '',
          product_code: productDetails?.code || '',
        }),
      });

      if (!res?.ack) {
        showMessage("error", res?.message || "Failed to save product files");
        return;
      }
      // const allFiles = [...files, ...profileFiles, ...galleryFiles];
      // if (allFiles.length === 0) {
      //   showMessage("info", "No files to upload");
      //   return;
      // }

      const allFiles = [
        ...(Array.isArray(files) ? files : []),
        ...(profileFiles ? [profileFiles] : []),
        ...(Array.isArray(galleryFiles) ? galleryFiles : []),
      ];

      if (allFiles.length === 0) {
        showMessage("info", "No files to upload");
        return;
      }


      const uploadPromises = allFiles.map(async (f) => {
        try {
          const uploadUrl = await getUploadUrl(f);
          await uploadFileToS3(uploadUrl, f.file, f.file.type);
        } catch (error) {
          console.error("Error uploading file:", f.file?.name, error);
          throw new Error(`Upload failed for ${f.file?.name}`);
        }
      });

      // Step 3: Await all uploads
      await Promise.allSettled(uploadPromises);

      navigate('/products');

      // Step 4: Success feedback
      showMessage("success", res?.message || "Product files uploaded successfully");
    } catch (err) {
      console.error("saveProductFiles error:", err);
      showMessage("error", err?.message || "Something went wrong");
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const getProductFiles = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product/product-files?product_netsuite_id=${id}`)
      if (res?.ack) {
        setCurrentItemFiles(res?.product_files?.files ? JSON.parse(res?.product_files?.files) : [])
        // setCurrentItemFilesProfile(res?.product_files?.profile_image ? JSON.parse(res?.product_files?.profile_image) : []);
        let profileImage = res?.product_files?.profile_image;

        try {
          if (typeof profileImage === 'string' && profileImage.startsWith('"')) {
            profileImage = JSON.parse(profileImage);
          }
        } catch {
          profileImage = res?.product_files?.profile_image || '';
        }

        setCurrentItemFilesProfile(profileImage || '');

        // setCurrentItemFilesProfile(res?.product_files?.profile_image || '');
        setCurrentItemFilesGallery(res?.product_files?.gallery_images ? JSON.parse(res?.product_files?.gallery_images) : []);
      } else {
        // showMessage('error',res?.message)
        console.log(res?.message);

      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong')
    }
    finally {
      hideLoading(layoutDispatch);
    }
  }

  const productInfo = [
    {
      label: 'Product',
      value: `${products?.find((item) => item.netsuite_id == id)?.code} - ${products?.find((item) => item.netsuite_id == id)?.name}`,
      type: 'text',
    },
  ]
  const productOtherInfo = [

    {
      label: 'Category',
      value: ` ${products?.find((item) => item.netsuite_id == id)?.sub_category}`,
      type: 'text'

    },
    {
      label: 'Total Stock',
      value: Number(totalStock).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      type: 'text'

    },
  ]

  return (
    <>
      <Flex justify="space-between" align="center">

        <h3>Product Details</h3>
        <Button
          icon={<ArrowLeftOutlined />}
          style={{ marginRight: "10px" }}
          onClick={onClickCancel}
        >
          Back
        </Button>
      </Flex>


      {id > 0 && (
        <>
          <DetailsGrid infoItems={productInfo} fullWidth={true} />
          <DetailsGrid infoItems={productOtherInfo} />
          <FileImageSection
            title="Profile Image"
            icon={<PictureOutlined style={{ color: "#faad14" }} />}
            items={currentItemFilesProfile}
            newItems={profileFiles}
            handleDeleteOld={handleDeleteCurrentFileProfile}
            handleDeleteNew={handleDeleteFileProfile}
            baseUrl={wms_uploads_cdn}
            folderName={"warehouse-products"}
            env={env}
            id={id}
            renderImage
            uploadLabel="Add Profile Image"
            uploadHandler={submitProfileImage}
            uploadLimit={1}
            accept="image/*,video/*"
            single
          />




          <FileImageSection
            title="Gallery Images"
            icon={<InboxOutlined style={{ color: "#722ed1" }} />}
            items={currentItemFilesGallery}
            newItems={galleryFiles}
            handleDeleteOld={handleDeleteCurrentFileGallery}
            handleDeleteNew={handleDeleteFileGallery}
            baseUrl={wms_uploads_cdn}
            folderName={"warehouse-products"}
            env={env}
            id={id}
            renderImage
            uploadLabel="Add Gallery Images"
            uploadHandler={submitGalleryImage}
            uploadLimit={10}
            accept="image/*,video/*"
          />
          <FileImageSection
            title="Files"
            icon={<FileOutlined style={{ color: "#1677ff" }} />}
            items={currentItemFiles}
            newItems={files}
            handleDeleteOld={handleDeleteCurrentFile}
            handleDeleteNew={handleDeleteFile}
            baseUrl={wms_uploads_cdn}
            folderName={"warehouse-products"}
            env={env}
            id={id}
            uploadLabel="Add Files"
            uploadHandler={submitImage}
            uploadLimit={10}
          />


          {canAccess && (
            <Flex justify="center" gap={5} style={{ marginTop: "20px" }}>

              <Button
                type="primary"
                size="large"
                // block
                icon={<DownloadOutlined />}
                style={{
                  fontWeight: 600,
                  letterSpacing: 0.5,
                  backgroundColor: "#1677ff",
                  borderColor: "#1677ff",
                  boxShadow: "0 4px 10px rgba(22,119,255,0.3)",
                }}
                onClick={saveProductFiles}
              >
                Save All New Files
              </Button>

            </Flex>
          )}

          <div className="detail-box" style={{ marginTop: '30px' }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
              <span className="detail-box-heading">
                Picking Locations
              </span>
              {canAccess && (
                <Button
                  onClick={() => {
                    setAddLocationModalOpen(true)
                  }}
                  type="primary" icon={<PlusOutlined />}>Add Picking Location</Button>
              )}
            </div>

            {allProductLocations?.length > 0 && <Table dataSource={allProductLocations} columns={allProductLocationsCol} style={{ marginTop: "4px" }} pagination={false} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} scroll={{ x: 'max-content' }} />}

          </div>

          <div className="detail-box" style={{ marginTop: '30px' }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
              <span className="detail-box-heading">
                Stock
              </span>

            </div>
            <Table dataSource={productLocations} columns={productLocationsCol} style={{ marginTop: "4px" }} pagination={false} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} scroll={{ x: 'max-content' }} />
          </div>



        </>
      )}

      <Modal width={600} title={
        <>
          <span style={{ fontWeight: 200 }} >{`Add Picking Location for `}
          </span>
          <span >
            {`${productDetail?.code} - ${productDetail?.title}`}
          </span>
        </>
      } open={addLocationModalOpen} onOk={handleOk} onCancel={handleModalCancel} okText="Save">
        <Divider style={{ margin: '10px 0px' }} />
        <Row>
          <Col xs={24} sm={12} md={16} lg={16} xl={16}>
            <span>
              Location<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={newLocationDetail.location_id}
              placeholder="Picking Location."
              optionFilterProp="search"
              //       filterOption={(input, option) =>
              //   option?.label?.props?.children
              //     ?.map?.((el) => (typeof el === 'string' ? el : ''))
              //     .join(' ')
              //     .toLowerCase()
              //     .includes(input.toLowerCase())
              // }
              filterOption={(input, option) =>
                option?.search?.toLowerCase().includes(input.toLowerCase())
              }
              optionLabelProp="label"
              onChange={(value) => {
                const locObj = locations?.find((loc) => loc?.id == value)
                setNewLocationDetail({ ...newLocationDetail, location_id: value, aisle: locObj?.aisle_id })
              }}
            >

              {locations?.filter(loc => loc?.is_picking === 1)?.map((item) => {
                const baseLabel = `${item.code} - ${item.title}`;

                const tags = (
                  <Space size={4}>
                    {item?.is_picking > 0 && (
                      <Tag color="green">Picking</Tag>
                    )}
                    {item?.is_binning > 0 && (
                      <Tag color="warning">Binning</Tag>
                    )}
                    {item?.is_transit > 0 && (
                      <Tag color="red">Transit</Tag>
                    )}
                  </Space>
                );


                return (
                  <Option
                    key={item.id}
                    value={item.id}
                    label={
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>
                          {tags} {baseLabel}
                        </span>
                      </div>
                    }
                    search={`${item.code} ${item.title}`}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        {tags} {baseLabel}
                      </span>
                    </div>
                  </Option>
                );
              })}
            </Select>
          </Col>
        </Row>

      </Modal>
    </>
  );
}
